import { AppAnalyticsService, getTrackedRouteFromRoutesPath, TrackedRoute } from "@domain/analytics/analytics-types";
import { RoutesPath, routesPaths } from "@ui/navigation/routes";
import { Location, matchRoutes, Params } from "react-router";

export class AnalyticsRoutesManager {
	private _currentRoute: { title: TrackedRoute; url?: string } | undefined;

	constructor(private readonly analyticsService: AppAnalyticsService) {
		this._currentRoute = undefined;
	}

	setCurrentRoute(location: Location): void {
		const routeData = this.getRouteDataFromLocation(location);
		if (routeData?.trackedRoute) {
			const baseUrl = window.location.origin;

			const pathName = this.getPathName(routeData);
			const search = this.getSearch(location);

			const customUrl = baseUrl + pathName + (search === "?" ? "" : search);

			if (routeData.trackedRoute !== this._currentRoute?.title || customUrl !== this._currentRoute.url) {
				this._currentRoute = { title: routeData.trackedRoute, url: customUrl };
				this.analyticsService.trackView(routeData.trackedRoute, customUrl);
			}
		}
	}

	private getPathName(routeData: { params: Params<string>; realPath: string }): string {
		return routeData.params.patientId
			? routeData.realPath.replace(`/${routeData.params.patientId}`, "")
			: routeData.realPath;
	}

	private getSearch(location: Location): string {
		const programIdParam = new URLSearchParams(location.search).get("programId");
		return programIdParam
			? location.search.replace(`&programId=${programIdParam}`, "").replace(`programId=${programIdParam}`, "")
			: location.search;
	}

	private getRouteDataFromLocation(
		location: Location,
	): { path: RoutesPath; params: Params<string>; realPath: string; trackedRoute: TrackedRoute | null } | null {
		const currentRoute = matchRoutes(
			routesPaths.map(route => ({ path: route })),
			location,
		)?.[0];
		const routePath = currentRoute?.route.path;
		if (currentRoute && routePath) {
			const trackedRoute = getTrackedRouteFromRoutesPath(routePath, location.search);
			return { path: routePath, realPath: currentRoute.pathname, params: currentRoute.params, trackedRoute };
		}
		return null;
	}
}
